<template>
	<div class="page" style="position: relative;">
		<el-image src="https://file.aavisa.com/browser-upload-file/84f5227e-e4c9-460e-84df-9aaf434029db.jpg" fit="fill"
			style="width: 100%;"></el-image>
		<div class="box">
			
			<div class="title">
				<p>联系我们</p>
			</div>
			
			<div class="tt">
				<p>同业联系: 18929395504（企业微信）</p>
				<p>技术合作 & 产品建议: 18925203111</p>
				<p>地址: 广东省深圳市罗湖区嘉宾路2018号深华商业大厦2721室</p>				
			</div>						
		
		</div>
		<el-image src="https://file.aavisa.com/browser-upload-file/902931e7-55de-471c-9374-d76aba69b67c.jpg" fit="fill" style="position: absolute;bottom: 0;left: 0;right: 0;"></el-image>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		created() {

		},
		methods: {
			
		}
	}
</script>

<style lang='less' scoped>
	.page {
		text-align: left;
		background-color: #fff;
		.box {
			overflow: hidden;
			width: 75rem;
			height: 49.375rem;
			margin: 0rem auto 0rem;
			
		}

		&>div {}

		.title {
			color: #333333;
			font-size: 2rem;
			text-align: center;
			font-weight: 600;
			margin-top: 4.625rem;
			margin-bottom: 3.375rem;
		}

		.tt {
			padding: 0 3.125rem;
			margin-bottom: 1.25rem;

			&>p {
				// margin-bottom: 2.275rem;
				margin-top: 0;
				// line-height: 2.0rem;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/contactus/contactus.vue